import {FunctionalComponent, h} from "preact";
import './scrollButt.scss';
import {IcoScrollButt} from "../components/icons";

export const ScrollButt: FunctionalComponent <{
    scrollButtonCB: () => void; marginBottom: string }> =
    ({ scrollButtonCB, marginBottom }) => {
    return (
        <a onClick={(e) => {e.preventDefault(); scrollButtonCB()}}
           className="scrollButt"
           style={{marginBottom}}>
          <IcoScrollButt />
        </a>
    );
};
